<div aria-labelledby="inlcudes-tab" class="tab-pane tab-content fade" id="hotalRoomPackage" role="tabpanel">

    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p>{{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <form>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-8 offset-2">
                            <div class="empty-data green">
                                <p>
                                    You can add, edit, or delete room package .
                                </p>
                            </div>
                            <div class="mb-3" v-if="!ui.status.canAdd">
                                <a @click.prevent="showAddPackageButton()" class="btn default-btn" href=""><i class="fas fa-plus"></i> Add new package</a
                                >
                            </div>
                        </div>
                    </div>

                    <div class="form-group row" v-if="ui.status.canAdd">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Package Title</label
                        >
                        <div class="col-sm-4">
                            <div class="form-group">
                <input type="text" class="form-control"
                        :class="{ 'error-input' : ui.error.errors['title'] }"
                        id=""
                        name=""
                        placeholder="eg. Package title."
                        v-model="item.addPackage.title"
                ></input>
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'title'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>

                        </div>
                         <label class="col-sm-0 col-form-label" for="staticEmail">
                            Price</label>
                         <div class="col-sm-4">
                 
                  <input type="text" class="form-control"
                        :class="{ 'error-input' : ui.error.errors['price'] }"
                        id=""
                        name="" id="inputPassword1" v-model="item.addPackage.price" placeholder="eg 200"/>
                         <validation-error
                                        :errors="ui.error.errors"
                                        :field="'price'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                </div>
                        <div class="col-sm-10" >
                             <label class="col-sm-2 col-form-label" for="staticEmail">
                            Services</label>
                          <div class="form-check form-check-inline" v-for="(list, index) in item.serviceList">
                        <input class="form-check-input" name="service" type="checkbox" :id="list.id" :value="list.id" v-model="serviceData">
                       <label class="form-check-label" :for="list.id">{{ list.title }}</label>
  
                         </div>
                        </div>
                        <div class="col-sm-2">
                            <a
                                    @click.prevent="addPackage"
                                    class="btn btn-sm add-btn"
                                    href="#"
                                    role="button"
                            >{{buttonTextAddPackage}}
                                <spinner
                                        :loading="ui.status.postLoading.create"
                                        v-if="ui.status.postLoading.create"
                                ></spinner>
                            </a>
                            </div>
                        </div>

                        <div :key="index" class="form-group row" v-for="(list, index) in item.packageList">
                            <div class="col-lg-8 offset-lg-2">
                                <div class="empty-data">
                                    <p v-if="item.packageList.length == 0">
                                        No Package List
                                    </p>
                                </div>

                                <div class="includes-list-item">
                                    <div class="includes-list hoverable-list readonly" v-if="!list.IsActive">
                                        <!-- <label class="readonly"><span v-if="list.icon">{{list.icon.name}}</span></label> -->
                                        <div class="list-ico">
                                            {{ index+1}}
                                        </div>
                                        <div class="includes-description">
                                            <p>{{ list.title }} <strong class="badge badge-secondary">Price</strong> {{list.price}}</p>
                                        </div>

                                        <!-- delete modals -->
                                    </div>

                                    <div class="includes-list editable" v-if="list.IsActive">
                                        <div class="row">
                                            <label class="col-sm- col-form-label" for="staticEmail">PackageTitle</label>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" :class="{ 'error-input' : ui.error.errors['edit_title'] }" id="" name="" placeholder="eg. Package title." v-model="list.title"></input>
                                                    <validation-error :errors="ui.error.errors" :field="'edit_title'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                                                </div>

                                            </div>

                                            <label class="col-sm-0 col-form-label" for="staticEmail"> Price</label>
                                            <div class="col-sm-3">

                                                <input type="text" class="form-control" :class="{ 'error-input' : ui.error.errors['edit_price'] }" id="" name="" id="inputPassword1" v-model="list.price" placeholder="eg 200" />
                                                <validation-error :errors="ui.error.errors" :field="'edit_price'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                                            </div>
                                            <div class="col-sm-10">
                                                <label class="col-sm-2 col-form-label" for="staticEmail">
                                                  Services</label>
                                                <div class="form-check form-check-inline" v-for="(serviceL, index) in item.serviceList">
                                                    <!-- <input v-if="serviceData.id == '1'" class="form-check-input" name="service" type="checkbox" :id="CC.id" :value="serviceData.id" v-model="editService" checked> -->
                                                    <input class="form-check-input" name="service" :value="serviceL.id" type="checkbox" :id="serviceL.id" :checked="list.package_service.find((ps)=>(ps.service_id==serviceL.id))">
                                                    <label class="form-check-label" :for="serviceL.id">{{ serviceL.title }} </label>
                                                </div>
                                            </div>

                                            <div class="col-lg-2">
                                                <div class="includes-action justify-content-start">
                                                    <button @click.prevent="editPackage()" class="btn green" type="button" v-if="list.IsActive">
                                                    <i class="fas fa-save"></i>
                                                </button>
                                                    <button @click.prevent="cancelPackage(index, list)" class="btn red" type="button" v-if="list.IsActive">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="includes-action">
                                    <button @click.prevent="onEditPackageClick(index, list)" class="btn blue" type="button" v-if="!ui.status.canEdit">
                                    <i class="fas fa-pen"></i>
                                </button>
                                    <button @click.prevent="onDeletePackageClick(index, list)" class="btn red" type="button">
                                    <i class="fas fa-minus"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
            </form>

            <div class="modal-wrap">
                <div aria-labelledby="exampleModalLabel" class="modal fade show" id="deleteSelectedPackage" role="dialog" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Delete Package</h5>
                                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="error-list" v-if="ui.error.modal.delete">
                                <ul class="error-msg">
                                    <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                            <div class="modal-body">
                                <p>
                                    Are you sure you want to delete this ?
                                </p>
                            </div>

                            <div class="modal-footer">
                                <button @click.prevent="deletePackage()" class="btn default-btn" type="button">
                                    Ok
                                    <spinner :loading="ui.status.postLoading.delete" v-if="ui.status.postLoading.delete"></spinner>
                                </button>
                                <button :disabled="ui.status.postLoading.delete" @click.prevent="hideDeleteModal" aria-label="Close" class="btn default-btn cancel" type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>